import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store'; // Upewnij się, że ścieżka jest poprawna
import styles from './FixcenterNavigation.module.scss';
import { Breadcrumb } from '../../../store/reducers'; // Importuj interfejs Breadcrumb
import { useTranslation } from '../../../i18n/useTranslation';

interface IInputProps {
    breadcrumbsTranslationCodes?: Record<string, string>;
}

const FixcenterNavigation: React.FC<IInputProps> = ({ breadcrumbsTranslationCodes }) => {
    const breadcrumbs = useSelector((state: RootState) => state.breadcrumbs.breadcrumbs);
    const { t } = useTranslation('translation');

    const getLabel = (breadcrumb: Breadcrumb): string | ReactNode => {
        if (breadcrumb.isToTranslate) {
            return t(breadcrumb.label);
        } else if (breadcrumbsTranslationCodes && breadcrumb.label in breadcrumbsTranslationCodes) {
            return breadcrumbsTranslationCodes[breadcrumb.label];
        }
        return breadcrumb.label;
    };

    return (
        <nav className={styles.breadcrumbs}>
            {breadcrumbs.map((breadcrumb: Breadcrumb, index: number) => (
                <div
                    key={index}
                    className={styles.linkWrapper}
                    style={{ '--z-index': breadcrumbs.length - index } as React.CSSProperties}
                >
                    {breadcrumb.link ? (
                        <Link
                            to={breadcrumb.link}
                            className={`${styles.breadcrumbs__item} ${index === breadcrumbs.length - 1 ? styles.active : ''}`}
                        >
                            {getLabel(breadcrumb)}
                        </Link>
                    ) : (
                        <span
                            className={`${styles.breadcrumbs__item} ${index === breadcrumbs.length - 1 ? styles.active : ''}`}
                        >
                            {getLabel(breadcrumb)}
                        </span>
                    )}
                </div>
            ))}
        </nav>
    );
};

export default FixcenterNavigation;
